import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
// Dynamic redux
export const reduxModuleLoaded = createAction(`${reduxKey}.REDUX_READY`, ()=>({}));
export const fetchGroupGallections = createAction(`${reduxKey}.FETCH_GROUP_GALLECTIONS`, (groupid, type)=>({
        groupid,
        type
    }));
export const fetchGroupGallectionsSuccess = createAction(`${reduxKey}.FETCH_GROUP_GALLECTIONS.SUCCESS`, (groupid, type, gallectionids)=>({
        groupid,
        type,
        gallectionids
    }));
export const fetchGroupGallectionsError = createAction(`${reduxKey}.FETCH_GROUP_GALLECTIONS.ERROR`, (message)=>({
        message
    }));
